import { render, staticRenderFns } from "./ConfirmLetter.vue?vue&type=template&id=9246c01c"
import script from "./ConfirmLetter.vue?vue&type=script&lang=js"
export * from "./ConfirmLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports